// extracted by mini-css-extract-plugin
export default {"tile":"_3QRDnURUwNC7E6OQtuODrm","dark":"_3kYoM5VJFUHSxYjYjnzC0I","tileDisabled":"_30hqE0U6vxpulta4BVv0zL"};